import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { createFunctionResult, FUNCTION_RESULT_STATUS, FunctionResult, IObjectKey, isObjectKey } from '@nova/common-interfaces';
import { FUNCTION_NAME, IAsset } from '@rfm/shared-interfaces';
import { CommonService } from '../../../../lib/services/index.mjs';

@Injectable({
  providedIn: 'root',
})
export class AssetService extends CommonService<IAsset, IObjectKey> {
  public override deleteFunctionName: FUNCTION_NAME = FUNCTION_NAME.ASSETS_ASSET_REMOVE;
  public override insertFunctionName: FUNCTION_NAME = FUNCTION_NAME.ASSETS_ASSET_INSERT;
  public override mergeFunctionName:  FUNCTION_NAME = FUNCTION_NAME.ASSETS_ASSET_MERGE;
  public override updateFunctionName:  FUNCTION_NAME = FUNCTION_NAME.ASSETS_ASSET_UPDATE;
  public override getAllFunctionName:  FUNCTION_NAME = FUNCTION_NAME.ASSETS_ASSET_GETALL;
  public override getFunctionName:  FUNCTION_NAME = FUNCTION_NAME.ASSETS_ASSET_GET;
  public override getKeysFunctionName:  FUNCTION_NAME = FUNCTION_NAME.ASSETS_ASSET_GETKEYS;
  public getByCustomerFunctionName: FUNCTION_NAME = FUNCTION_NAME.ASSETS_ASSET_GETBYCUSTOMER;
  public removeFunctionName: FUNCTION_NAME = FUNCTION_NAME.ASSETS_ASSET_REMOVE;
  public refreshFunctionName: FUNCTION_NAME = FUNCTION_NAME.ASSETS_ASSET_REFRESH;
  public assignFunctionName: FUNCTION_NAME = FUNCTION_NAME.ASSETS_ASSET_ASSIGN;

  constructor(functions: Functions) {
    super(functions);
  }

  public async refresh(key: IObjectKey | string): Promise<FunctionResult<IAsset>> {
    this.isLoading(true);
    console.debug("Calling Function", this.refreshFunctionName.toString());

    return new Promise<FunctionResult<IAsset>>((resolve, reject) => {
      const callable = httpsCallable<any, FunctionResult<IAsset>>(
        this.functions,
        this.refreshFunctionName.toString()
      );
      callable(key)
        .then(
          (result) => {
            console.debug("Result", result.data);
            resolve(result.data);
          },
          (error) => {
            console.error(error);
            reject(error);
          }
        )
        .finally(() => {
          this.isLoading(false);
        });
    });
    }

    public async assign(asset_id: IObjectKey | string, subscription_id: IObjectKey | string): Promise<FunctionResult<IAsset>> {
      this.isLoading(true);
      console.debug("Calling Function", this.assignFunctionName.toString());
  
      return new Promise<FunctionResult<IAsset>>((resolve, reject) => {
        const callable = httpsCallable<any, FunctionResult<IAsset>>(
          this.functions,
          this.assignFunctionName.toString()
        );
        callable({
          "asset": asset_id,
          "subscription": subscription_id
        })
          .then(
            (result) => {
              console.debug("Result", result.data);
              resolve(result.data);
            },
            (error) => {
              console.error(error);
              reject(error);
            }
          )
          .finally(() => {
            this.isLoading(false);
          });
      });
      }
      
      /**
   * Update object of type T
   * Allows for optional refreshing of the service's objects collection (Default: false)
   * @param { T } obj
   * @param { boolean} refresh
   * @return { Promise<T> }
   */
  public async remove(key: IObjectKey | string): Promise<FunctionResult<IAsset>> {
    this.isLoading(true);
    console.debug("Calling Function", this.removeFunctionName.toString());

    return new Promise<FunctionResult<IAsset>>((resolve, reject) => {
      const callable = httpsCallable<any, FunctionResult<IAsset>>(
        this.functions,
        this.removeFunctionName.toString()
      );
      callable(key)
        .then(
          (result) => {
            console.debug("Result", result.data);
            resolve(result.data);
          },
          (error) => {
            console.error(error);
            reject(error);
          }
        )
        .finally(() => {
          this.isLoading(false);
        });
    });
  }
  
  public async getByCustomer(key: IObjectKey | string): Promise<FunctionResult<IAsset[]>> {
    this.isLoading(true);

  let myId = "";
    if (isObjectKey(key)) {
      console.log("service-get isObjectKey", key);
      myId = (key as IObjectKey).id;
    } else {
      myId = key as string;
    }

    return new Promise<FunctionResult<IAsset[]>>((resolve, reject) => {
      const callable = httpsCallable<IObjectKey | string, FunctionResult<IAsset[]>>(
        this.functions,
        this.getByCustomerFunctionName.toString()
      );
      callable(myId)
        .then(
          (result) => {
            console.debug("Result", result.data);
            resolve(result.data);
          },
          (error) => {
            console.error(error);
            reject(createFunctionResult<IAsset[] | null>(FUNCTION_RESULT_STATUS.ERROR, null));
          }
        )
        .finally(() => {
          this.isLoading(false);
        });
    });
  }
}
